import { useTranslation } from "react-i18next";
import React from "react";
import {
	Stack,
	ThemeSpaceVariable,
	ThemeFontSizeVariable,
	ThemeColorVariable,
	ThemeFontVariable,
	Message,
	Heading,
} from "@caspeco/casper-ui-library";
import { useOrderStore } from "store/orderStore";
import { formatRelativeTimeAndDayWithLocale } from "helpers/time-helper/time-helper";
import { useBaseColorValue } from "components/base-color-context/BaseColorContext";

export default function OrderMessages() {
	const { order } = useOrderStore();
	const { t } = useTranslation();
	const { baseColor } = useBaseColorValue();

	let labelTextColor;
	switch (baseColor) {
		case "background":
			labelTextColor = ThemeColorVariable.OnBackgroundHeader;
			break;
		case "surface":
		default:
			labelTextColor = ThemeColorVariable.OnSurfaceHeader;
			break;
	}

	return (
		<Stack mt={ThemeSpaceVariable.XLarge}>
			<Heading
				as="h3"
				fontSize={ThemeFontSizeVariable.Large}
				fontFamily={ThemeFontVariable.SubHeader}
				fontWeight="medium"
				color={labelTextColor}
				mb={ThemeSpaceVariable.XSmall}
			>
				{t("messages")}
			</Heading>
			<Stack spacing={ThemeSpaceVariable.Small}>
				{order?.messages.map((message) => (
					<React.Fragment key={message.id}>
						<Message
							time={formatRelativeTimeAndDayWithLocale(message.createdAt.toString(), order.placeTimezone)}
						>
							{message.message}
						</Message>
					</React.Fragment>
				))}
			</Stack>
		</Stack>
	);
}
